import * as S from './LotsList.styled';
import Table from './components/Table';
import { LotsListItemsSelector, removeLot } from './LotsListSlice';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { IsOwnerSelector } from 'features/User/UserSlice';
import { openEditLotModal } from 'features/EditLotModal/EditLotModalSlice';
import { ComplexesListItemsSelector } from 'features/ComplexesList/ComplexesListSlice';
import { IComplex, IRegion, ILot, IOrganization } from 'interfaces/main';
import { Divider, Flex, Typography } from 'antd';
import { MinusSquareOutlined, PlusCircleOutlined, PlusSquareOutlined } from '@ant-design/icons';
import { openCreateLotModal } from 'features/CreateLotModal/CreateLotModalSlice';
import { JSX } from 'react/jsx-runtime';
import { OrganizationsListItemsSelector } from 'features/OrganizationsList/OrganizationsListSlice';
import { useState } from 'react';
import { LibrariesSelector } from 'features/Libraries/LibrariesSlice';

const { Text } = Typography;

const LotsList = (): JSX.Element => {
	const [opened, setOpened] = useState(
		localStorage.getItem('logsTables') ? JSON.parse(localStorage.getItem('logsTables')) : [],
	);

	const dispatch = useAppDispatch();

	// Список лотов
	const lots = useAppSelector(LotsListItemsSelector);

	// Список ЖК
	const complexes = useAppSelector(ComplexesListItemsSelector);

	// Доступные организации
	const allOrganizations = useAppSelector(OrganizationsListItemsSelector);

	// Словари
	const { regions: allRegions } = useAppSelector(LibrariesSelector);

	// Подтвержденность пользователя
	// const isAccepted = useAppSelector(IsAcceptedSelector);
	const isOwner = useAppSelector(IsOwnerSelector);

	// Открытие модалки с карточкой лота для редактирования
	const onOpenOldLotModal = (lotId: number) => dispatch(openEditLotModal(lotId));

	// Удаление лота
	const onRemoveLot = (lotId: number) => dispatch(removeLot(lotId));

	// Открытие модалки создания лота
	const onOpenNewLotModal = (complexId: number) =>
		dispatch(openCreateLotModal({ complexId }));

	const onToggleOpened = (complexId: number) => {
		const result = opened.includes(complexId)
			? opened.filter((item: number) => item !== complexId)
			: [...opened, ...[complexId]];

		localStorage.setItem('logsTables', JSON.stringify(result));
		setOpened(result);
	};

	return (
		<S.Wrap>
			{complexes.map((complex: IComplex) => (
				<S.Section key={complex.id}>
					<Divider orientation="left">
						<Flex gap={12}>
							<Flex onClick={() => onToggleOpened(complex.id)}>
								{opened.includes(complex.id) ? (
									<MinusSquareOutlined style={{ cursor: 'pointer', color: '#1890ff' }} />
								) : (
									<PlusSquareOutlined style={{ cursor: 'pointer', color: '#1890ff' }} />
								)}
							</Flex>
							<Text>
								{isOwner
									? `${complex.title} (${lots.filter((lot: ILot) => lot.complexId === complex.id).length}) (${allOrganizations?.find((item: IOrganization) => item.id === complex.organizationId)?.title || '-'}) (${allRegions?.find((item: IRegion) => item.id === complex.regionId)?.name_en || '-'})`
									: `${complex.title} (${lots.filter((lot: ILot) => lot.complexId === complex.id).length}) (${allRegions?.find((item: IRegion) => item.id === complex.regionId)?.name_en || '-'})`}
							</Text>
							{isOwner && (
								<PlusCircleOutlined
									onClick={() => onOpenNewLotModal(complex.id)}
									style={{ cursor: 'pointer', color: '#1890ff' }}
								/>
							)}
						</Flex>
					</Divider>
					{opened.includes(complex.id) && (
						<Table
							items={lots.filter((lot: ILot) => lot.complexId === complex.id)}
							isDisabled={!isOwner}
							onEdit={onOpenOldLotModal}
							onRemove={onRemoveLot}
						/>
					)}
				</S.Section>
			))}
		</S.Wrap>
	);
};

export default LotsList;
